// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // FIXME: use PPE settings
  adManagementServiceBaseUrl: 'https://01u3v1emyl.execute-api.eu-west-1.amazonaws.com/prod/',
  photoAssetsBaseUrl: 's3-eu-west-1.amazonaws.com/assets.drapeauimmobilier.com/photos',
  authorizationHeader: 'Authorization',
  googleClientId: '579444064751-fmqbao9e4thg3he4inh3f1uapaq8l845.apps.googleusercontent.com'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
